export default __webpack_public_path__ + "29e06c318f8e76c307a6827a4ff4445e.png";